const DB_NAME = 'Seen-tv-db';
const DB_VERSION = 20;

const stores: any = {
  filerefs: { name: 'filerefs', keyPath: 'id', indexes: ['last_opened_at'] },
  blust_results: { name: 'blust_results', keyPath: 'id' },
  uploads: { name: 'uploads', keyPath: 'id' },
  converted_files: { name: 'converted_files', keyPath: 'id' },
  metadata: { name: 'metadata', keyPath: 'id' as 'fingerprint' },//not used?
  analysis: { name: 'analysis', keyPath: 'id' },
  debuginfo: { name: 'debuginfo', keyPath: 'id' },
  speaker_labels: { name: 'speaker_labels', keyPath: 'id' },
  storyline_visibility: { name: 'storyline_visibility', keyPath: 'id' },
  settings: { name: 'settings', keyPath: 'key' },
};

export const openDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = (event: any) => {
      reject('Database error: ' + event.target.errorCode);
    };
    request.onsuccess = (event: any) => {
      resolve(event.target.result);
    };
    request.onupgradeneeded = (event: any) => {
      const db = event.target.result;
      Object.keys(stores).forEach(key => {
        const storeDef = stores[key]
        if (!db.objectStoreNames.contains(storeDef.name)) {
          const store = db.createObjectStore(storeDef.name, { keyPath: storeDef.keyPath });
          stores[key].indexes?.forEach((indexname: string) => {
            store.createIndex(indexname, indexname, { unique: false });
            console.log("Index added:", indexname);
          });
        } else {
          const store = event.currentTarget.transaction.objectStore(stores[key].name);
          stores[key].indexes?.forEach((indexname: string) => {
            if (!store.indexNames.contains(indexname)) {
              store.createIndex(indexname, indexname, { unique: false });
              console.log("Index added:", indexname);
            } else {
              console.log("Index already exists:", indexname);
            }
          });
        }
      });
    };
  });
};

export const listItems = async (storename: string, skip: number = 0, limit: number = 10, order_by: string = "", reverse: boolean = false): Promise<any[]> => {
  const db = await openDB();
  console.log("trying to list from ",storename)
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storename], 'readonly');
    const store = order_by ? transaction.objectStore(storename).index(order_by) : transaction.objectStore(storename);
    const direction = reverse ? 'prev' : 'next';
    const results: any[] = [];
    let count = 0;

    const request = store.openCursor(null, direction);
    request.onsuccess = (event: any) => {
      const cursor = event.target.result;
      if (cursor) {
        if (count >= skip && count < skip + limit) {
          results.push(cursor.value);
        }
        count++;
        if (results.length < limit) {
          cursor.continue();
        } else {
          resolve(results);
        }
      } else {
        resolve(results);
      }
    };
    request.onerror = (event: any) => {
      reject('Load error: ' + event.target.errorCode);
    };
  });
};

export const saveItem = async (storename: string, item: any): Promise<void> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storename], 'readwrite');
    const store = transaction.objectStore(storename);
    console.log("trying to save item",item);
    const request = store.put(item);
    request.onsuccess = () => {
      resolve();
    };
    request.onerror = (event: any) => {
      reject('Save error: ' + event.target.errorCode);
    };
  });
};

export const getItem = async (storename: string, id: string): Promise<any> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storename]);
    const store = transaction.objectStore(storename);
    const request = store.get(id);
    request.onsuccess = (event: any) => {
      resolve(event.target.result);
    };
    request.onerror = (event: any) => {
      reject('Load error: ' + event.target.errorCode);
    };
  });
};

export const deleteItem = async (storename: string, id: string): Promise<void> => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction([storename], 'readwrite');
    const store = transaction.objectStore(storename);
    const request = store.delete(id);
    request.onsuccess = () => {
      resolve();
    };
    request.onerror = (event: any) => {
      reject('Delete error: ' + event.target.errorCode);
    };
  });
};
